import React from 'react';
import styles from './DeleteButton.module.css';


export default function DeleteButton({ handleDelete }) {

    return (
        <div className={styles.buttonContainer}>
            <button onClick={handleDelete} className={styles.deleteButton}>Delete User</button>
        </div>

    );
};